import styled from 'styled-components'

const Container = styled.ul`
  padding: 3px;
  background-color: #eaeaff;
  display: flex;
  align-items: center;
  gap: 3px;
  margin: 0;
  border-radius: 48px;
`

const Item = styled.li<{ isActive?: boolean }>`
  list-style-type: none;
  padding: 5px 12px;
  border-radius: 24px;
  background-color: ${({ isActive }): string => (isActive ? '#fff' : 'transparent')};
  color: ${({ isActive }): string => (isActive ? '#28265d' : '#5D59D7')};
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
  line-height: 130%;
`

export default {
  Container,
  Item
}
